var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicHolidayNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 91,
    viewBox: "0 0 111 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2213 3.54004L1.00369 81.8323C0.991196 81.945 1.01058 82.059 1.05963 82.1613C1.10869 82.2636 1.18545 82.3501 1.28119 82.4109C1.37694 82.4717 1.48783 82.5045 1.60126 82.5055C1.7147 82.5064 1.82613 82.4756 1.9229 82.4164L7.84668 78.7714C8.19828 78.5535 8.62076 78.4807 9.02505 78.5682C9.42934 78.6557 9.78385 78.8968 10.0138 79.2406L17.4569 90.3062L20.5624 43.7586L10.2213 3.54004Z",
    fill: "#8AE8E8",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1675 5.50977L1.8372 79.8762C1.8192 80.0367 1.84844 80.199 1.92133 80.3432C1.99421 80.4873 2.10759 80.607 2.24753 80.6877C2.38748 80.7683 2.54792 80.8064 2.70918 80.7972C2.87044 80.788 3.02551 80.7319 3.15537 80.6358L7.4865 77.4442C7.71174 77.2776 7.96862 77.1587 8.24141 77.0948C8.51419 77.031 8.79714 77.0235 9.07293 77.0728C9.34871 77.1221 9.61154 77.2271 9.8453 77.3816C10.0791 77.536 10.2789 77.7365 10.4324 77.9708L15.5008 85.7075C15.5558 85.7934 15.6379 85.8585 15.7341 85.8923C15.8303 85.9261 15.9351 85.9267 16.0318 85.894C16.1284 85.8614 16.2113 85.7972 16.2672 85.7119C16.3231 85.6266 16.3488 85.525 16.3403 85.4234L10.4229 5.51296C10.4167 5.48388 10.4008 5.45776 10.3779 5.4389C10.3549 5.42004 10.3262 5.40956 10.2965 5.40919C10.2667 5.40882 10.2378 5.41858 10.2143 5.43686C10.1909 5.45514 10.1744 5.48085 10.1675 5.50977Z",
    fill: "#8AE8E8",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2.32237 79.9257L10.2117 9.50543L7.17816 77.0354L7.17793 77.0356C7.17777 77.0357 7.17762 77.0358 7.17746 77.0359L2.84703 80.2271L2.84631 80.2276C2.7947 80.2658 2.73306 80.2881 2.66896 80.2918C2.60487 80.2954 2.5411 80.2803 2.48547 80.2482C2.42983 80.2162 2.38477 80.1686 2.35581 80.1113C2.32683 80.054 2.31521 79.9895 2.32237 79.9257L1.82548 79.87L2.32237 79.9257Z",
    fill: "black",
    stroke: "#71BBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73742 77.0298C9.07272 77.0356 9.40152 77.1233 9.69522 77.2852C9.98892 77.447 10.2386 77.6782 10.4226 77.9586L15.491 85.6952C15.546 85.7812 15.6281 85.8463 15.7243 85.8801C15.8206 85.9139 15.9253 85.9145 16.022 85.8818C16.1186 85.8491 16.2015 85.785 16.2574 85.6997C16.3133 85.6144 16.339 85.5128 16.3305 85.4112L15.6059 75.6318L8.62891 76.9979C8.66599 77.0051 8.70232 77.0158 8.73742 77.0298Z",
    fill: "#8AE8E8",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.3871 77.1631L15.149 76.2308L15.8197 85.2845L10.8409 77.6846L10.8407 77.6842C10.7133 77.4901 10.5605 77.315 10.3871 77.1631Z",
    fill: "black",
    stroke: "#71BBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 3.49316L17.4542 90.3072L99.5925 74.6552L80.2891 6.94977L10.4102 3.49316Z",
    fill: "#2E353A",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2148 5.36621L19.0535 85.7171L96.2924 71.6736L80.0116 9.24731L14.2148 5.36621Z",
    fill: "#8AE8E8",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9414 44.9086L22.615 82.9951L92.794 70.2347L86.2734 41.6084L18.9414 44.9086Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4853 81.099L31.3203 68.8652",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.225 79.2053L42.1016 69.0078",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7532 77.1658L52.4414 69.0078",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5998 75.3061L63.0391 65.5811",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1552 73.5829L72.8242 64.0908",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.318 71.8881L81.3359 60.4746",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1807 28.5477C15.1739 28.4537 15.1675 28.3656 15.1617 28.2837L91.1235 54.4708L92.8959 62.937C81.1346 67.8506 63.5254 72.1366 48.764 75.2065C41.3098 76.7567 34.5927 77.9947 29.7391 78.8451C27.3124 79.2703 25.3518 79.5986 23.9982 79.8205C23.3214 79.9315 22.7963 80.0158 22.4406 80.0724C22.4145 80.0766 22.3892 80.0806 22.3648 80.0845L22.3429 79.9829C22.2645 79.6184 22.1508 79.0881 22.0097 78.425C21.7274 77.0989 21.3356 75.2422 20.8971 73.1197C20.0201 68.8734 18.9577 63.5685 18.2138 59.3217C17.473 55.0928 16.6966 47.1546 16.1046 40.2526C15.8089 36.8061 15.5598 33.6252 15.3846 31.3058C15.297 30.1461 15.2279 29.2019 15.1807 28.5477Z",
    fill: "#8AE8E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1807 28.5477C15.1739 28.4537 15.1675 28.3656 15.1617 28.2837L91.1235 54.4708L92.8959 62.937C81.1346 67.8506 63.5254 72.1366 48.764 75.2065C41.3098 76.7567 34.5927 77.9947 29.7391 78.8451C27.3124 79.2703 25.3518 79.5986 23.9982 79.8205C23.3214 79.9315 22.7963 80.0158 22.4406 80.0724C22.4145 80.0766 22.3892 80.0806 22.3648 80.0845L22.3429 79.9829C22.2645 79.6184 22.1508 79.0881 22.0097 78.425C21.7274 77.0989 21.3356 75.2422 20.8971 73.1197C20.0201 68.8734 18.9577 63.5685 18.2138 59.3217C17.473 55.0928 16.6966 47.1546 16.1046 40.2526C15.8089 36.8061 15.5598 33.6252 15.3846 31.3058C15.297 30.1461 15.2279 29.2019 15.1807 28.5477Z",
    stroke: "#71BBBB"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 4.49219L79.6847 8.11476C79.6847 8.11476 86.2309 27.7277 92.7451 38.8029C99.2594 49.8781 110.003 49.1567 110.003 49.1567C110.003 49.1567 85.3627 62.6289 66.1711 69.8006C46.1975 77.2596 28.8761 78.6001 28.8761 78.6001C28.8761 78.6001 13.0996 57.0498 12.4453 4.49219Z",
    fill: "#8AE8E8",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1423 1C18.8943 1 17.9911 2.10752 17.707 3.8438L18.9837 3.91402C19.1816 2.91183 19.5742 2.27668 20.1391 2.27668C20.7966 2.27668 21.5275 3.33313 21.5275 4.85237C21.5275 6.37162 20.7966 7.43126 20.1391 7.43126C19.9698 7.43126 19.8074 7.49851 19.6877 7.61822C19.568 7.73794 19.5008 7.9003 19.5008 8.0696C19.5008 8.2389 19.568 8.40126 19.6877 8.52097C19.8074 8.64068 19.9698 8.70794 20.1391 8.70794C21.6328 8.70794 22.8042 7.01315 22.8042 4.85237C22.8042 2.69159 21.636 1 20.1423 1Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9745 5.88574C21.9133 6.11083 21.8344 6.33069 21.7383 6.54323",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 3.26884C18.3359 3.26884 18.8147 1.53894 20.2286 1.63469C21.3393 1.71129 22.2553 3.36139 22.1021 5.1264",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2282 1.55859C29.9803 1.55859 29.077 2.66611 28.793 4.40239L30.0696 4.47261C30.2675 3.47042 30.6601 2.83527 31.225 2.83527C31.8825 2.83527 32.6134 3.89172 32.6134 5.41096C32.6134 6.93021 31.8825 7.98985 31.225 7.98985C31.0557 7.98985 30.8934 8.05711 30.7737 8.17682C30.654 8.29653 30.5867 8.45889 30.5867 8.62819C30.5867 8.79749 30.654 8.95985 30.7737 9.07957C30.8934 9.19928 31.0557 9.26653 31.225 9.26653C32.7188 9.26653 33.8901 7.57174 33.8901 5.41096C33.8901 3.25019 32.7251 1.55859 31.2282 1.55859Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0643 6.44434C33.0032 6.66943 32.9242 6.88929 32.8281 7.10182",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4258 3.82841C29.4258 3.82841 29.9045 2.09851 31.3185 2.19426C32.4292 2.27086 33.3452 3.92096 33.192 5.68597",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.322 2.11719C41.074 2.11719 40.1708 3.22471 39.8867 4.96099L41.1634 5.0312C41.3613 4.02901 41.7539 3.39386 42.3188 3.39386C42.9763 3.39386 43.7072 4.45031 43.7072 5.96956C43.7072 7.4888 42.9763 8.54845 42.3188 8.54845C42.1495 8.54845 41.9871 8.6157 41.8674 8.73541C41.7477 8.85512 41.6804 9.01749 41.6804 9.18679C41.6804 9.35608 41.7477 9.51845 41.8674 9.63816C41.9871 9.75787 42.1495 9.82512 42.3188 9.82512C43.8125 9.82512 44.9839 8.13033 44.9839 5.96956C44.9839 3.80878 43.8157 2.11719 42.322 2.11719Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1542 7.00293C44.093 7.22802 44.014 7.44788 43.918 7.66042",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5195 4.38603C40.5195 4.38603 40.9983 2.65613 42.4122 2.75188C43.5229 2.82848 44.4389 4.47858 44.2857 6.24359",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4157 2.67578C52.1678 2.67578 51.2645 3.7833 50.9805 5.51958L52.2571 5.5898C52.455 4.58761 52.8476 3.95246 53.4125 3.95246C54.07 3.95246 54.8009 5.00891 54.8009 6.52815C54.8009 8.0474 54.07 9.10704 53.4125 9.10704C53.2432 9.10704 53.0809 9.17429 52.9612 9.29401C52.8415 9.41372 52.7742 9.57608 52.7742 9.74538C52.7742 9.91468 52.8415 10.077 52.9612 10.1968C53.0809 10.3165 53.2432 10.3837 53.4125 10.3837C54.9062 10.3837 56.0776 8.68893 56.0776 6.52815C56.0776 4.36738 54.9094 2.67578 53.4157 2.67578Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2479 7.56152C55.1868 7.78661 55.1078 8.00647 55.0117 8.21901",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6094 4.94462C51.6094 4.94462 52.0881 3.21472 53.5021 3.31047C54.6128 3.38707 55.5288 5.03718 55.3756 6.80218",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7094 3.1709C63.4615 3.1709 62.5582 4.27842 62.2773 6.01789L63.554 6.08811C63.7551 5.08591 64.1477 4.44758 64.7094 4.44758C65.3669 4.44758 66.101 5.50722 66.101 7.02646C66.101 8.54571 65.3669 9.60216 64.7094 9.60216C64.5401 9.60216 64.3778 9.66941 64.258 9.78912C64.1383 9.90883 64.0711 10.0712 64.0711 10.2405C64.0711 10.4098 64.1383 10.5722 64.258 10.6919C64.3778 10.8116 64.5401 10.8788 64.7094 10.8788C66.2063 10.8788 67.3777 9.18724 67.3777 7.02646C67.3777 4.86569 66.2063 3.1709 64.7094 3.1709Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.537 8.05957C66.4763 8.28379 66.3973 8.50263 66.3008 8.71387",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9023 5.44292C62.9023 5.44292 63.3843 3.70983 64.795 3.80558C65.9089 3.88218 66.8217 5.53549 66.6717 7.30049",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5571 3.76758C74.3091 3.76758 73.4059 4.8751 73.125 6.61138L74.4017 6.68479C74.6028 5.68259 74.9953 5.04426 75.5571 5.04426C76.2146 5.04426 76.9486 6.1039 76.9486 7.61995C76.9486 9.13601 76.2146 10.1988 75.5571 10.1988C75.3878 10.1988 75.2254 10.2661 75.1057 10.3858C74.986 10.5055 74.9187 10.6679 74.9187 10.8372C74.9187 11.0065 74.986 11.1688 75.1057 11.2886C75.2254 11.4083 75.3878 11.4755 75.5571 11.4755C77.054 11.4755 78.2253 9.78073 78.2253 7.61995C78.2253 5.45918 77.054 3.76758 75.5571 3.76758Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3885 8.6377C77.3284 8.86311 77.2494 9.08305 77.1523 9.29519",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 6.02398C73.75 6.02398 74.2319 4.29089 75.6427 4.38664C76.7566 4.46324 77.6694 6.11335 77.5194 7.87835",
    stroke: "#71BBBB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5181 38.8534C85.8933 30.9891 81.0356 18.5702 79.3088 13.9997L19.2188 11.5645C19.1805 55.9769 32.6239 74.3259 32.6239 74.3259C32.6239 74.3259 47.9281 73.1418 65.5782 66.5478C82.5388 60.2122 102.768 49.5775 102.768 49.5775C102.768 49.5775 96.2727 48.6424 90.5181 38.8534Z",
    fill: "white",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3088 13.9997L19.2188 11.5645C19.2188 15.9339 19.3432 20.0448 19.573 23.9163L83.0303 23.3227C81.3865 19.4064 80.062 15.9754 79.3088 13.9997Z",
    fill: "#2E353A",
    stroke: "#71BBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3672 27.2386L83.2078 27.1396",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0195 27.5234L78.2401 27.3096",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9141 27.8641L69.9092 27.5928",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6328 28.213L60.1514 27.9258",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6875 28.551L49.4976 28.2861",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2148 28.9087L39.0313 28.6406",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9961 29.2206L29.27 28.9717",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8086 36.067L86.9181 32.0391",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2578 35.499C31.2578 35.499 32.343 53.0789 43.932 72.5929",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 34.7949C41.9219 34.7949 43.1443 54.9026 55.8504 69.6259",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5781 34.2002C51.5781 34.2002 52.2165 52.712 66.4993 66.015",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5938 33.7695C61.5938 33.7695 63.1704 54.3496 76.9937 61.5979",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0859 32.9434C72.0859 32.9434 73.1966 48.5093 87.3358 57.0343",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3438 32.4385C80.3438 32.4385 84.1482 48.3969 94.7925 53.5643",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2578 45.1351L89.7813 37.708",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 53.0796C24.0195 53.0796 38.4364 52.5147 92.9218 42.4736",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 61.4888C26.5625 61.4888 40.6059 63.0846 95.6244 45.5654",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 68.8271C29.6016 68.8271 41.3087 72.705 98.8166 48.0811",
    stroke: "#71BBBB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1303 17.5222L23.1303 17.5222L23.1301 17.5212C23.1269 17.4909 23.1301 17.4603 23.1395 17.4314C23.149 17.4025 23.1645 17.3759 23.185 17.3534C23.2055 17.3309 23.2305 17.313 23.2585 17.3009C23.2863 17.2889 23.3163 17.2828 23.3465 17.2832C23.3467 17.2832 23.3468 17.2832 23.347 17.2832L44.7299 17.6534C44.73 17.6534 44.73 17.6534 44.73 17.6534C44.7785 17.6543 44.8253 17.6711 44.8633 17.7011C44.9014 17.7312 44.9285 17.7729 44.9405 17.8199L44.9411 17.8224L45.3749 19.484C45.3749 19.4841 45.3749 19.4843 45.375 19.4844C45.383 19.5159 45.3838 19.5488 45.3774 19.5807L45.8673 19.6805L45.3774 19.5807C45.3708 19.6126 45.3571 19.6427 45.3372 19.6686L45.7338 19.9732L45.3372 19.6686C45.3173 19.6945 45.2918 19.7156 45.2626 19.7301C45.2345 19.7441 45.2037 19.7518 45.1724 19.7526L23.5342 19.4623C23.5341 19.4623 23.534 19.4623 23.5339 19.4623C23.4797 19.4614 23.4276 19.4409 23.3873 19.4046C23.3475 19.3687 23.3218 19.3199 23.3149 19.2669L23.1303 17.5222Z",
    fill: "white",
    stroke: "#71BBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicHolidayNoData);
export default __webpack_public_path__ + "static/media/Public_Holiday_NoData.b6439fa717769e7ae1804fc013cfe447.svg";
export { ForwardRef as ReactComponent };